module.exports = __webpack_public_path__ + "img/ricelog_pinicon_062.7379a468.png";